import b from 'b_';
import React from 'react';

import Image from '../../image/image';
import { useIntl } from '../../intl/context';
import { CERTIFICATE_LAYOUT } from '../types';

import './certificate-banner__image.scss';

interface Props {
    src: string | null;
    layout: CERTIFICATE_LAYOUT;
    style?: React.CSSProperties;
}

export const CertificateBannerImage = React.memo(({ src, layout, style }: Props) => {
    const intl = useIntl();
    const certificateImageAlt = intl.formatMessage({ id: 'certificate.imageAlt' });

    if (!src) {
        return null;
    }

    return (
        <Image
            alt={certificateImageAlt}
            className={b('certificate-banner', 'image', { layout })}
            src={src}
            style={style}
        />
    );
});
